import React, { useState, useEffect } from 'react';
import backToTopImg from '../version1/img/backtotop.webp';

const BackToTopButton = () => {
  const [isVisible, setIsVisible] = useState(false);

  const scrollToTop = () => {
    console.log('BackToTopButton clicked, scrolling to top');
    window.scrollTo({ top: 0, behavior: 'smooth' });
    document.documentElement.scrollTo({ top: 0, behavior: 'smooth' });
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  };

  useEffect(() => {
    const toggleVisibility = () => {
      if (window.pageYOffset > 200 || document.documentElement.scrollTop > 200 || document.body.scrollTop > 200) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener('scroll', toggleVisibility);
    document.addEventListener('scroll', toggleVisibility);
    document.body.addEventListener('scroll', toggleVisibility);

    // Check visibility on mount
    toggleVisibility();

    return () => {
      window.removeEventListener('scroll', toggleVisibility);
      document.removeEventListener('scroll', toggleVisibility);
      document.body.removeEventListener('scroll', toggleVisibility);
    };
  }, []);

  const buttonStyle = {
    position: 'fixed',
    bottom: '20px',
    right: '20px',
    cursor: 'pointer',
    zIndex: 1000,
    width: '50px',
    height: '50px',
    border: 'none',
    background: 'transparent',
    padding: 0,
    display: isVisible ? 'block' : 'none',
  };

  return (
    <button
      onClick={scrollToTop}
      style={buttonStyle}
      title="Back to top"
      aria-label="Back to top"
    >
      <img
        src={backToTopImg}
        alt="Back to top"
        style={{ width: '100%', height: '100%', display: 'block' }}
      />
    </button>
  );
};

export default BackToTopButton;
